module.exports = __webpack_public_path__ + "static/media/callin.75a061d8.svg";